import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse, EventDeleteRequest, EventGetListRequest, EventGetListResponse, EventInsertRequest } from '../models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllEvents(body: EventGetListRequest) {
    const link = this.apiUrl + ApiUrls.getEvents;
    return this.http.post<EventGetListResponse>(link, body).pipe(
      map((response: any) => this.attachEventCalendarDimensions(response))
    );
  }

  getEvent(id: any) {
    const link = this.apiUrl + ApiUrls.getEvent;
    return this.http.get<any>(link+"/"+id );
  }

  deleteEvent(body: EventDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deleteEvent;
    return this.http.post<BaseResponse>(link, body);
  }

  insertEvent(body: FormData) {
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    });
    const link = this.apiUrl + ApiUrls.insertEvent;
    return this.http.post<BaseResponse>(link, body,{headers:headers});
  }
  updateEvent(body: EventInsertRequest) {
    const link = this.apiUrl + ApiUrls.updateEvent;
    return this.http.post<BaseResponse>(link, body);
  }

  getEventStatusCount() {
    const link = this.apiUrl + ApiUrls.getEventCountStatus;
    return this.http.get<any>(link);
  }

  private attachEventCalendarDimensions(response: any): any {
    const items = response?.data?.items || response?.data || [];
    if (!Array.isArray(items)) {
      return response;
    }

    const yearSet = new Set<number>();
    const yearMonthSet = new Set<string>();

    for (const event of items) {
      const dateCandidates = [
        event?.eventDate,
        event?.eventStartDate,
        event?.eventEndDate,
        event?.startDate,
        event?.endDate
      ];

      for (const rawDate of dateCandidates) {
        if (!rawDate) {
          continue;
        }
        const parsed = new Date(rawDate);
        if (Number.isNaN(parsed.getTime())) {
          continue;
        }
        const year = parsed.getFullYear();
        const month = parsed.getMonth() + 1;
        yearSet.add(year);
        yearMonthSet.add(`${year}-${month}`);
      }
    }

    const calendarDimensions = {
      years: Array.from(yearSet).sort((a, b) => a - b),
      yearMonths: Array.from(yearMonthSet)
        .map((value) => {
          const [year, month] = value.split('-').map((x) => Number(x));
          return { year, month };
        })
        .sort((a, b) => (a.year - b.year) || (a.month - b.month))
    };

    if (response?.data && typeof response.data === 'object') {
      return {
        ...response,
        data: {
          ...response.data,
          calendarDimensions
        }
      };
    }

    return {
      ...response,
      calendarDimensions
    };
  }
}
